import React from 'react';

import { type GalleryLabel as GalleryLabelType } from '@/types/gallery';

const GalleryLabel: React.FC<GalleryLabelType> = ({
  title,
  artwork_media,
  height,
  length,
  depth,
  price,
  comments,
}): React.JSX.Element => {
  const formatDimensions = (height?: number, length?: number, depth?: number | null): string =>
    height && length ? `${height} × ${length}${depth ? ` × ${depth}` : ''} cm` : '';

  const currencyFormatter = new Intl.NumberFormat('en-GB', {
    currency: 'GBP',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: 'currency',
  });

  const formatPrice = (price?: number): string =>
    typeof price === 'number' ? currencyFormatter.format(price) : '';

  const dimensions = formatDimensions(height, length, depth);
  const formattedPrice = formatPrice(price);

  const details = [
    { label: 'Title:', value: title },
    { label: 'Materials and techniques:', value: artwork_media },
    { label: 'Dimensions:', value: dimensions },
    { label: 'Price:', value: formattedPrice },
    { label: 'Comments:', value: comments?.trim() },
  ];

  return (
    <dl className="wall-label">
      {details.map(
        (detail) =>
          detail.value && (
            <React.Fragment key={detail.label}>
              <dt>{detail.label}</dt>
              <dd>{detail.value}</dd>
            </React.Fragment>
          ),
      )}
    </dl>
  );
};

export default GalleryLabel;
